export default __webpack_public_path__ + "static/media/human-body-2.9b129f21.svg";